import styled from 'styled-components'

import { EmptyState, Layout } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import NoResultsIllustration from '../assets/no-results.svg'

// As defined in
// https://www.figma.com/design/Cfeyx9kXJqMhm1fnLlRTjE/-Tokens--Miranda-4all?node-id=2829-11255&t=P2BcrsDSe33gN6vF-4
const MIRANDA_MOBILE_BREAKPOINT = '375px'

const IllustrationWrapper = styled(EmptyState.Illustration)`
  @media (max-width: ${MIRANDA_MOBILE_BREAKPOINT}) {
    display: none;
  }
`

const StyledLayoutStack = styled(Layout.Stack)`
  padding-top: ${getToken('spacing-20')};

  @media (max-width: ${MIRANDA_MOBILE_BREAKPOINT}) {
    padding-top: ${getToken('spacing-6')};
  }
`

export function EmptyShipmentsListState() {
  return (
    <StyledLayoutStack align="center">
      <EmptyState variant="page">
        <IllustrationWrapper>
          <img src={NoResultsIllustration} role="presentation" width="190px" alt="" />
        </IllustrationWrapper>
        <EmptyState.Header>No shipments found</EmptyState.Header>
        <EmptyState.Message>Change the terms of your search and try again</EmptyState.Message>
      </EmptyState>
    </StyledLayoutStack>
  )
}
